// Central place to manage all image imports
export const IMAGES = {
  // Hero Section
  hero: {
    main: 'https://i.postimg.cc/fyFbWq6q/main-hero-webp.webp',
    logo: 'https://i.postimg.cc/cC6HSG58/Logo-png.png'
  },

  // About Section
  about: {
    plate: 'https://i.postimg.cc/qBmhZjZ3/hotdog-plate-webp.webp'
  },

  // Did You Know Section
  didYouKnow: {
    sausages: 'https://i.postimg.cc/xCf86zv5/sausages-webp.webp',
    sandwiches: 'https://i.postimg.cc/Jhct3qkt/sandwiches-webp.webp',
    sauces: 'https://i.postimg.cc/cHFH2LTS/sauces-webp.webp'
  },

  // Team Section
  team: {
    benny: 'https://i.postimg.cc/sXr7sxpG/benny-webp.webp',
    brian: 'https://i.postimg.cc/Xq2Cfgt9/brian-webp.webp',
    decorative: 'https://i.postimg.cc/Qxy7V0Q3/decorative-webp.webp'
  },

  // Timeline Images
  timeline: {
    1964: {
      first: 'https://i.postimg.cc/Wb6PgY94/1966-webp.png',
      second: 'https://i.postimg.cc/zfTzrsRt/1966-webp.webp'
    },
    1999: 'https://i.postimg.cc/9FMTWvqb/1999-webp.webp',
    2000: 'https://i.postimg.cc/t4nx6WkV/2000-webp.webp',
    2006: 'https://i.postimg.cc/q7fCxqDD/2006-webp.webp',
    2013: 'https://i.postimg.cc/76wGjckg/2013-webp.webp',
    2017: 'https://i.postimg.cc/zfnHtN9z/2017-webp.webp',
    2019: 'https://i.postimg.cc/6Q1pqCm5/Foodtruck-1.jpg'
  },

  // Image Carousel
  carousel: [
    'https://i.postimg.cc/x8dk1zq8/image-1-webp.webp',
    'https://i.postimg.cc/j2kDwSJX/image-2-webp.webp',
    'https://i.postimg.cc/9FrR3ZvN/image-3-webp.webp',
    'https://i.postimg.cc/c42Kd6W1/image-4-webp.webp',
    'https://i.postimg.cc/4xcYyZ46/image-5-webp.webp',
    'https://i.postimg.cc/HLCV7Kjf/image-6-webp.webp'
  ],

  // Menu Section
  menu: {
    bench: 'https://i.postimg.cc/xC3HCQRx/bench.webp'
  },

  // Rental Section
  rental: {
    hero: 'https://i.postimg.cc/5y9zQrKx/hero-webp.webp',
    contact: 'https://i.postimg.cc/YSgY5Ymw/contact-webp.webp'
  },

  // Payment and Drinks Banners
  banners: {
    drinks: 'https://i.postimg.cc/xC3HCQRx/bench.webp',
    payment: 'https://i.postimg.cc/xC3HCQRx/bench.webp'
  },

  // Icons and Logos
  icons: {
    favicon: '/hotdog.svg',
    mobilePay: 'https://i.postimg.cc/138pKLmX/mobilepay-webp.webp',
    smiley: 'https://i.postimg.cc/qvW2DjqL/smiley-webp.webp',
    decorative: 'https://i.postimg.cc/Qxy7V0Q3/decorative-webp.webp'
  }
};